import types from './mutations-types';
import { uuidv4 } from '@/lib/functions/other';
import { MutationTree } from 'vuex';
import { MessagesStateShape } from 'store';

export default {
	[types.ADD_MESSAGE](state, message) {
		if (!message.id) {
			message.id = uuidv4();
		}
		state.globalMessages.push(message);
	},

	[types.REMOVE_MESSAGE](state, messageId) {
		state.globalMessages = state.globalMessages.filter((message) => message.id !== messageId);
	}
} as MutationTree<MessagesStateShape>;
